<div class="py-5 px-2">
	<div *ngIf="products && products.length > 0"
		 class="fb_search_result_list gap-4">
		<ng-container *ngFor="let product of products">
			<fb-search-product-preview class="my-2" [productListingData]="product"></fb-search-product-preview>
		</ng-container>
	</div>
</div>
